import { call, fork, select, takeLatest, takeEvery } from 'redux-saga/effects';

import { fetchTeams, searchTeams } from '../api';
import { teamsListActions } from './actions';

import { getCurrentTeamsList, getTeamsListById } from './selectors';

export function* loadTeamsList({payload}) {
  const { teamsListId } = payload;

  const teamsList = yield select(getTeamsListById, teamsListId);
  if (!teamsList || !teamsList.isPending)
    yield call(fetchTeams, teamsListId);
}

export function* searchTeamsList({payload}) {
  const { teamsListId, filters } = payload;

  const teamsList = yield select(getTeamsListById, teamsListId);
  if(!teamsList || teamsList?.isNew)
    yield call(searchTeams, teamsListId, { teamsListId, filters });
}
//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadTeamsList() {
  yield takeEvery(teamsListActions.LOAD_TEAMS, loadTeamsList);
}

export function* watchSearchTeamsList() {
  yield takeEvery(teamsListActions.SEARCH_TEAMS, searchTeamsList);
}


//=====================================
//  ROOT
//-------------------------------------

export const teamsListSagas = [
  fork(watchLoadTeamsList),
  fork(watchSearchTeamsList),
];
